// Add unique utils for Account Manager here. Consider putting all other utils into the rotec-components library

import { ToastDataV2, ToastV2Service } from '@schenck/rotec-components';

export function showSuccessToast(
  type: string,
  action: 'deleted' | 'created' | 'updated',
  service: ToastV2Service,
  positioning: 'top' | 'bottom' = 'bottom'
): void {
  service.open(<ToastDataV2>{
    positioning,
    text: `The ${type} was ${action} successfully`,
    type: 'success',
    title: 'Success',
  });
}

export function getTimestamp(): string {
  const date = new Date();
  const timestamp = `${date.getUTCFullYear()}-${date.getMonth() < 9 ? '0' : ''}${
    date.getMonth() + 1
  }-${date.getDate() < 10 ? '0' : ''}${date.getDate()}_${
    date.getHours() < 10 ? '0' : ''
  }${date.getHours()}-${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`;

  return timestamp;
}
